
import { DateTime } from 'luxon';
import * as XLSX from 'xlsx';

const DEFAULT_OUTPUT_FORMAT = 'yyyy-MM-dd';

const tryParseStringDate = (s) => {
  const value = String(s).trim();
  if (!value) return null;

  // ISO / RFC
  const iso = DateTime.fromISO(value, { setZone: false });
  if (iso.isValid) return iso;

  // Common formats (add more if you need)
  const formatsToTry = [
    'dd.MM.yy',
    'dd.MM.yyyy',
    'dd/MM/yy',
    'dd/MM/yyyy',
    'd/M/yyyy',
    'd/M/yy',
    'yyyy-MM-dd',
    'yyyy/MM/dd',
    'dd-MM-yyyy',
    'd-M-yyyy',
  ];

  for (const fmt of formatsToTry) {
    const dt = DateTime.fromFormat(value, fmt);
    if (dt.isValid) return dt;
  }

  return null;
};

const tryParseExcelSerial = (n) => {
  if (typeof n !== 'number' || !Number.isFinite(n)) return null;

  // XLSX.SSF.parse_date_code supports date serials; include date1904 awareness if you use it
  const d = XLSX.SSF.parse_date_code(n);
  if (!d || !d.y || !d.m || !d.d) return null;

  const dt = DateTime.fromObject({ year: d.y, month: d.m, day: d.d });
  return dt.isValid ? dt : null;
};

export function parseExcelDate(dateInput, { fallbackToToday = false } = {}) {
  let dt = null;

  if (dateInput == null || dateInput === '') {
    return fallbackToToday ? DateTime.now().toFormat(DEFAULT_OUTPUT_FORMAT) : null;
  }

  if (dateInput instanceof Date) {
    dt = DateTime.fromJSDate(dateInput);
  } else if (typeof dateInput === 'number') {
    dt = tryParseExcelSerial(dateInput);
  } else {
    dt = tryParseStringDate(dateInput);
  }

  if (!dt || !dt.isValid) {
    return fallbackToToday ? DateTime.now().toFormat(DEFAULT_OUTPUT_FORMAT) : null;
  }

  return dt.toFormat(DEFAULT_OUTPUT_FORMAT);
}




